import { DataGrid as MuiDataGrid, DataGridProps } from '@mui/x-data-grid';
import * as styles from '@components/dataGrid/FullPageDataGrid.styles';

const ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100];

export const DataGrid = ({ ...props }: DataGridProps) => {
  return (
    <MuiDataGrid
      disableColumnMenu
      disableRowSelectionOnClick
      sortingMode='server'
      paginationMode='server'
      pagination
      pageSizeOptions={ROWS_PER_PAGE_OPTIONS}
      sx={styles.dataGrid}
      // TODO: make sure this doesn't break other DataGrids
      columnHeaderHeight={72}
      columnBufferPx={4}
      {...props}
    />
  );
};
